// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federmontage/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federmontageDE: PageEntry = {
  id: "post.federmontage",
  locale: "de",
  slug: "federmontage",
  seo: {
    title: "Glossar: Federmontage einfach erklärt | Dietz GmbH",
    description: "Die Federmontage bezieht sich auf den Prozess der Installation oder Anbringung von Federn in einem mechanischen System. Dieser Schritt ist entscheidend, um sicherzustellen, dass di",
  },
  type: "post",
  h1: "Glossar: Federmontage einfach erklärt",
  intro: "Die Federmontage bezieht sich auf den Prozess der Installation oder Anbringung von Federn in einem mechanischen System. Dieser Schritt ist entscheidend, um sicherzustellen, dass die Feder ordnungsgemäß positioniert und gesichert ist. Die Federmontage erfordert präzise Handhabung und Ausrichtung, um eine optimale Funktion der Feder zu gewährleisten. In verschiedenen Anwendungen, von industriellen Maschinen bis zu Fahrzeugen, spielt die korrekte Federmontage eine Schlüsselrolle für die Leistung und Zuverlässigkeit des Gesamtsystems.",
  blocks: [

  ],
};
